import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Field } from '../../util/components/resource/resource-fields/resource-fields';
import { CourseTheme } from '../course-theme/course-theme.model';

@Endpoint('course-templates', 'CourseTemplate')
export class CourseTemplate extends ApiResource<CourseTemplate> {
  @Field()
  name!: string;

  @Field({ default: () => 100 })
  price!: number;

  @Field({ default: () => 0 })
  minAttendants!: number;

  @Field({ default: () => 20 })
  maxAttendants!: number;

  @Field({ default: () => 6 })
  minAge!: number;

  @Field({ default: () => 18 })
  maxAge!: number;

  @Field()
  theme!: CourseTheme;

  @Field()
  itemsToBring!: string;

  @Field({ default: () => false })
  displayOnSite!: boolean;
}
